import React from 'react';
import { cn } from '../utils/cn';

interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'destructive' | 'success';
}

export const Alert = ({ className, variant = 'default', ...props }: AlertProps) => {
  return (
    <div
      className={cn(
        'rounded-md p-4 border',
        {
          'bg-blue-50 border-blue-200 text-blue-800': variant === 'default',
          'bg-red-50 border-red-200 text-red-800': variant === 'destructive',
          'bg-green-50 border-green-200 text-green-800': variant === 'success',
        },
        className
      )}
      {...props}
    />
  );
};

export const AlertTitle = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => {
  return (
    <h4
      className={cn('font-medium text-lg mb-1', className)}
      {...props}
    />
  );
};

export const AlertDescription = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) => {
  return (
    <p
      className={cn('text-sm', className)}
      {...props}
    />
  );
};
